import CloseIcon from '@mui/icons-material/Close';

import React, { useState } from 'react';

import { ServiceTitanAdjustableCapacityDTO, TimezoneAbbreviationEnum } from '_lib/api/apiTypes.shim';
import { FlexBox } from '_lib/components/FlexBox/FlexBox';
import { IconButton } from '_lib/components/IconButton/IconButton';
import { TimePicker } from '_lib/components/Pickers/TimePicker/TimePicker';
import { Stack } from '_lib/components/Stack/Stack';
import { Tooltip } from '_lib/components/Tooltip/Tooltip';
import { Typography } from '_lib/components/Typography/Typography';

import { DateFormatEnum, DateUtils } from '_lib/utils/date.utils';
import { FieldIssueProps } from '_lib/utils/validationErrorUtils';

import { CapacityItemDisplay } from '../../CapacityBooking/CapacityItemDisplay/CapacityItemDisplay';

type CapacityItemClearableProps = {
  capacityItem: ServiceTitanAdjustableCapacityDTO;
  timezone: TimezoneAbbreviationEnum;
  appointmentTime: Date;
  onSetAppointmentTime: (appointmentTime: Date) => void;
  onClearCapacityItem: () => void;
} & FieldIssueProps;

export const CapacityItemClearable = (props: CapacityItemClearableProps) => {
  const { capacityItem, timezone, appointmentTime, onSetAppointmentTime, onClearCapacityItem, issues, issuePath } =
    props;

  const [initialAppointmentTime] = useState(appointmentTime);

  return (
    <FlexBox sx={{ flexDirection: 'column' }}>
      <Stack direction='row' sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant='body1Bold' text='CAPACITY ITEM' />
        <Tooltip title='Clear Capacity Item' placement='bottom'>
          <IconButton onClick={() => onClearCapacityItem()} sx={{ padding: 0 }}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Stack>
      <Typography
        sx={{ paddingY: 1 }}
        variant='body1Bold'
        text={DateUtils.format(capacityItem.start, DateFormatEnum.DateWeekday, { timezone: 'utc' })}
      />
      <CapacityItemDisplay capacityItem={capacityItem} timezone={timezone} />
      <FlexBox sx={{ paddingY: 1 }}>
        <TimePicker
          minTime={initialAppointmentTime}
          maxTime={DateUtils.setTimeZoneOffset(new Date(capacityItem.end), timezone)}
          label='Requested Time'
          timezone={timezone}
          value={appointmentTime}
          timeSteps={{ minutes: 30 }}
          skipDisabled
          textFieldProps={{ error: { issues, issuePath }, required: true }}
          onChange={(newValue) => {
            if (newValue) onSetAppointmentTime(newValue);
          }}
        />
      </FlexBox>
    </FlexBox>
  );
};
